// extracted by mini-css-extract-plugin
export default {"form-card":"Common_form-card__JcVGV","form-title":"Common_form-title__yk-Kk","form-actions":"Common_form-actions__UZYmt"};